import * as React from 'react'
import {connect} from "react-redux";
import {ActionType, reducerStoreType} from "../../reducers/types";
import {Dispatch} from "redux";
import FormControl from "@material-ui/core/FormControl";
import {MyInput, PrimaryButton, WhiteButton} from "../../components/CustomUIComp/CustomFormElem";
import './ManualQueryModal.scss'
import {injectIntl, IntlShape} from "react-intl";

interface IProps {
    dispatch: Dispatch<ActionType<any>>,
    onClose: () => void,
    onQuery:(orderNo: string) => void,
    intl: IntlShape
}

interface IState {
    orderNo: string,
}

class ManualQueryModal extends React.Component<IProps, IState> {
    private inputRef = React.createRef<HTMLInputElement>();
    private interval: number = 0;

    constructor(props: IProps) {
        super(props)
        this.state = {
            orderNo: '',
        }
    }

    componentDidMount() {
        this.interval = window.setInterval(() => {
            if (this.inputRef && this.inputRef.current) {
                this.inputRef.current.focus()
            }
        }, 1000)
    }

    componentWillUnmount() {
        console.log('unmount')
        if (this.interval > 0) {
            clearInterval(this.interval)
            this.interval = 0
        }
    }

    onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            orderNo: event.target.value
        })
    }

    onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            if (this.interval > 0) {
                clearInterval(this.interval)
                this.interval = 0
            }
            console.log('enter')
            this.query()
        }
    }

    query = () => {
        // todo校验
        this.props.onQuery(this.state.orderNo)
    }

    public render() {
        let {intl} = this.props
        return (<div className="manualQueryModal">
            <div className="tradeInfo">
                {intl.formatMessage({id: 'manualQueryOrderTips'})}
            </div>
            <FormControl className="formControl" fullWidth>
                <MyInput id="orderNo"
                         inputRef={this.inputRef}
                         autoFocus={true}
                         fullWidth
                         type="text"
                         name="orderNo"
                         placeholder={intl.formatMessage({id: 'queryOrderTips'})}
                         value={this.state.orderNo}
                         onKeyDown={this.onKeyDown}
                         onChange={this.onInputChange}
                />
            </FormControl>
            <div className="button-line">
                <WhiteButton onClick={this.props.onClose}>
                    {intl.formatMessage({id: 'cancel'})}
                </WhiteButton>
                <PrimaryButton onClick={this.query}>{intl.formatMessage({id: 'confirm'})}</PrimaryButton>
            </div>
        </div>);
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
    }
})(ManualQueryModal))
